<template>
  <div class="about">
    <section>
      <SectionHeader title="About us"></SectionHeader>
      <div class='common__section-body'>
        <p>
          We wish to introduce ourselves as one of leading Electrical Contractors undertaking
          transformer oil filtration at site.
        </p>
        <p>
          The Company was Founded & Established in the Year 1978 by two technocrats who are
          electrical engineers having vast experience in similar field.
        </p>
        <p>
          <b>This year we are in 45th Year of Operation.</b>
        </p>
        <p>
          TECHNOCOMERZ IS AN CLASS 1 ELECTRICAL CONTRACTOR, ESTD 1978 CEIG. (CHIEF
          ELECTRICAL, GOVT. OF INDIA) APPROVED COMPANY
        </p>
        <p>
          For the last 44 years, since we started this business of transformer oil filtration we have
          established a strong base and have become pioneers in this field in Karnataka and
          outside and many have emulated from us.
        </p>
        <p>
          We are approved by Government Electrical Inspector for testing and issuing of test
          certificate for transformers oil. We have innumerable satisfied customers.
        </p>
        <p>
          We have 2 different categories of machines for oil filtration and both are mobile for
          different capacity of transformers.
        </p>
      </div>
    </section>
    <hr class='common__section-divider' />
    <section>
      <SectionHeader title="Partners"></SectionHeader>
      <div v-bind:key="item.name" class='common__section-body about__partner-item' v-for="item in partners">
        <div class='about__partner-image'>
          <img :src="item.image">
          <label>{{item.name}}</label>
        </div>
        <p class='about__partner-description'>{{item.description}}</p>
      </div>
    </section>
    <hr class='common__section-divider' />
    <section>
      <SectionHeader title="Team"></SectionHeader>
      <div class='about__team-container'>
        <div v-bind:key="item.name" class='about__team-item' v-for="item in team">
          <img :src="item.image">
          <div class='about__team-item-detail'>
            <p>{{item.name}}</p>
            <p>{{item.experience}}</p>
            <p>{{item.description}}</p>
          </div>
        </div>
      </div>
    </section>
    <hr class='common__section-divider' />
    <section>
      <SectionHeader title="Class 1 License"></SectionHeader>
      <div class='about__certificate-container'>
        <img src='../assets/images/main/certificate1.jpg'>
        <img src='../assets/images/main/certificate2.jpg'>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
@import '../sass/_variables.scss';

.about__partner-item {
  display: flex;
  justify-content: center;
  margin: 20px 10px;
  padding: 25px 40px;

  @media (max-width: $md-screen) {
    display: block;
    padding: 20px;
    margin: 10px 0;
  } 
}

.about__partner-image {
  font-size: $fs-large;
  text-align: center;
  width: 220px;

  img {
    height: 175px;
  }

  label {
    white-space: nowrap;
  }

  @media (max-width: $md-screen) {
    display: block;
    width: 100%;

    label {
      display: block;
    }
  }
}

.about__partner-description {
  max-width: 780px;
  margin-top: 50px;
  margin-left: 50px;

  @media (max-width: $md-screen) {
    margin: 10px 0 0;
  }
}

.about__team-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.about__team-item {
  display: flex;
  align-items: center;
  min-width: 320px;
  width: calc(33% - 80px);
	margin: 20px;
	padding: 20px;
  box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.5);
  
  img {
    height: 125px;
  }
}

.about__team-item-detail {
  margin-left: 25px;

  p {
    margin: 10px 0;
  }
}
.about__certificate-container {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;

  img {
    max-width: calc(50% - 40px);

    @media (max-width: $md-screen) {
      max-width: calc(50% - 5px);
    }

    @media (max-width: $sm-screen) {
      max-width: 100%;
      margin: 5px 0;
    }
  }

  @media (max-width: $sm-screen) {
    flex-direction: column;
  }
}
</style>

<script>
import SectionHeader from '@/components/sectionHeader.vue'

export default {
  name: 'aboutUs',
  components: {
    SectionHeader,
  },
  data: () => ({
    partners: [{
      name: 'AK Nagaraj',
      description: 'The Company was founded by technocrat Mr. AK Nagaraj, an Electrical Engineer from University of Mysore. Who was formerly working in Transformer Division of Crompton Greaves Ltd. at Mumbai and Chennai.',
      image: require('../assets/images/team/AKNagaraj.png')
    }, {
      name: 'CK Vasudev Murthy',
      description: 'Mr. CKV Murthy who is also an Electrical Engineer. Joined the organisation as Chief of Finance & Operations later that year and have been continuing the services till date,',
      image: require('../assets/images/team/CKVMurthy.png')
    }, {
      name: 'Krishna Nagaraj',
      description: 'In 2002, Mr. Krishna Nagaraj, son of Mr. AK Nagaraj after completion his degree in Mechanical Engineering was inducted into the company and have been serving the organisation as Chief of Marketing and Operations.',
      image: require('../assets/images/team/KrishnaNagaraj.png')
    }],
    team: [{
      name: 'Prakash',
      experience: '15+ Years Experience',
      description: 'Technician',
      image: require('../assets/images/team/Prakash.png')
    }, {
      name: 'Srinivas Rao',
      experience: '',
      description: 'Civil and Electrical Operations',
      image: require('../assets/images/team/SrinivasRao.png')
    }, {
      name: 'Yeshwanth Kumar',
      experience: '',
      description: 'Technician and Office Staff',
      image: require('../assets/images/team/YeshwanthKumar.png')
    }, {
      name: 'Ravi .N',
      experience: '',
      description: 'Professional Painting Personnel',
      image: require('../assets/images/team/RaviN.png')
    }]
  })
}
</script>